import { render, staticRenderFns } from "./RecapCard.vue?vue&type=template&id=4dc34db0&scoped=true"
import script from "./RecapCard.vue?vue&type=script&lang=ts"
export * from "./RecapCard.vue?vue&type=script&lang=ts"
import style0 from "./RecapCard.vue?vue&type=style&index=0&id=4dc34db0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc34db0",
  null
  
)

export default component.exports